/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { DashboardService } from './services/dashboard.service';
import { FileManagerService } from './services/file-manager.service';
import { MeetingsService } from './services/meetings.service';
import { TaskService } from './services/task.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    DashboardService,
    FileManagerService,
    MeetingsService,
    TaskService,
    ApiConfiguration
  ],
})
export class TMApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<TMApiModule> {
    return {
      ngModule: TMApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: TMApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('TMApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
